import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "signals" }
const _hoisted_3 = { class: "dots-button pointer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_TopicTile = _resolveComponent("TopicTile")
  const _component_PulseNum = _resolveComponent("PulseNum")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TrackerSelect = _resolveComponent("TrackerSelect")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["topic-item pointer", {chosen: $props.chosenId === $props.item.id}]),
    onClick: _cache[2] || (_cache[2] = $event => (_ctx.$dispatch('edit-topic', {topic_id: $props.item.id})))
  }, [
    _createVNode(_component_Divider, { m: "0" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TopicTile, {
        name: $props.item.name
      }, null, 8 /* PROPS */, ["name"]),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PulseNum, {
          count: $props.item.signals,
          max: 100,
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($props.item.signals && _ctx.$dispatch('set-entity', $props.item.shared_topic_id)), ["stop"]))
        }, null, 8 /* PROPS */, ["count"])
      ]),
      _createElementVNode("div", {
        class: "actions",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_TrackerSelect, { options: $options.options }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Icon, {
                icon: "ellipsis-01",
                size: "1.6rem",
                fill: "var(--brand-400)"
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["options"])
      ])
    ]),
    _createVNode(_component_TrackerDelete, { ref: "delete" }, null, 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}